import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import {} from 'shared/actions/auth.action';
import { initModal } from 'shared/actions/modal.action';

import * as input from 'web/components/common/modal/common/input';

@connect(state => ({ modal: state.shared.modal }), { initModal })
class DisconnectContainer extends Component {
  render() {
    return (
      <Dim>
        <div style={{ position: 'relative' }}>
          <Disconnect initModal={this.props.initModal} />
        </div>
      </Dim>
    );
  }
}

export default DisconnectContainer;

const Disconnect = React.memo(({ initModal }) => {
  return (
    <div
      className={'Disconnect'}
      onClick={e => e.stopPropagation()}
      style={{
        minHeight: '150px',
        padding: '15px 30px 50px',
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        borderRadius: '10px',
        overflow: 'hidden',
      }}
    >
      <div
        className="standding-message"
        style={{ fontSize: '16px', lineHeight: '1.6', marginTop: '20px' }}
      >
        네트워크 상태를 확인해주세요.
      </div>
      <input.BottomButton
        type={'submit'}
        msg={``}
        onClick={initModal}
        buttonStyle={{
          backgroundColor: '#9576ea',
          color: '#fff',
          borderRadius: '0 0 10px 10px',
        }}
      >
        확인
      </input.BottomButton>
    </div>
  );
});
